import { mapActions, mapGetters } from 'vuex'
import rvheader from '@/components/rvheader.vue'
import dashboardcontainer from '@/components/dashboardcontainer.vue'
import post from '@/components/post.vue'
import searchresults from '@/components/searchresults.vue'
import globaloutlook from '@/components/globaloutlook.vue'
import analyst from '@/components/analyst.vue'
import localStorage from '@/api/localStorage'
import { SITE_URL } from '@/api/config'
import $ from 'jquery'
import { urlParam } from '@/helper'
// import ScrollingDocument from '@/components/ScrollingDocument.vue'

import {
  FETCH_TABS,
  REMOVETAB,
  CHANGEACTIVETAB,
  RESET_ORDER_BY_FROM_HOME
} from '@/store/actions.type'

export default {
  mounted() {
    // console.log('Component mounted.')
  },
  name: 'rvdashboard',
  components: {
    rvheader,
    dashboardcontainer,
    analyst,
    searchresults,
    post,
    globaloutlook
    // ScrollingDocument
  },
  created() {
    this.applytheme()
  },

  beforeMount() {
    var self = this
    setTimeout( function () {
      self.changeTabbasedurl()
    }, 500 )
  },
  data() {
    return {
      // tabs: '',
      tabCountExternal: 0,
      tabForPanarayCount: 0,
      tabCounter: 1,
      tabIndex: 0,
      theme: '',

      globalOutlook: '',
      heightStyle: '',
      auth: this.$store.state.auth.isAuthenticated
      // scrollTop: 6,
      // clientHeight: 0,
    }
  },
  computed: {
    cravings() {
      if (
        this.$store.state.appsetting.theme === 'd' &&
                this.$store.state.appsetting.panaray === true
      ) {
        return 'draktheme'
      } else if (
        this.$store.state.appsetting.theme === 'l' &&
                this.$store.state.appsetting.panaray === true
      ) {
        return 'lightheme'
      } else {
        return 'webapp'
      }
      return this.$store.state.appsetting.theme === 'l'
        ? 'lightheme'
        : 'draktheme'
    },
    showItemState() {
      /*	setTimeout(function() {
      this.tabIndex = this.$store.getters.activeTabIndex
      }, 1000) */
      // console.log( 'tab Index', this.$store.getters.activeTabIndex )
      this.tabIndex = this.$store.getters.activeTabIndex
      // this.tabs = this.$store.getters.tabsData
      return this.$store.getters.activeTabIndex
    },
    tabs() {
      /*	setTimeout(function() {
      this.tabIndex = this.$store.getters.activeTabIndex
      }, 1000) */
      // this.tabIndex = this.$store.getters.activeTabIndex
      // return this.$store.getters.tabsData
      return this.$store.state.rvtabs.data
      return ( this.tabs = this.$store.rvtabs.data )
      // return this.$store.getters.activeTabIndex
    }
  },
  methods: {
    ...mapActions( {
      fetchTabsData: FETCH_TABS,
      removetab: REMOVETAB,
      changeactivetab: CHANGEACTIVETAB,
      resetsearchfiletr: RESET_ORDER_BY_FROM_HOME
    } ),
    ...mapGetters( ['tabsData', 'activeTabIndex', 'activetabid'] ),
    changeTabbasedurl() {
      var tabid = urlParam.tab
      if ( tabid == 'post' ) {
        tabid = urlParam.pid
      }
      localStorage.savelocalStorage( 'serachResultload', 'true' )
      /* if parameter not set then changing tab */
      if ( urlParam ) {
        if ( tabid ) {
          $( '#tabID' + tabid ).trigger( 'click' )
        } else {
          $( '#tabIDDashboard' ).trigger( 'click' )
        }
      } else {
        if ( tabid === undefined ) {
          if (
            localStorage.getlocalStorage( 'login' ) == null &&
                        localStorage.getlocalStorage( 'reloadStatus' ) == null
          ) {
            if ( this.tabForPanarayCount === 0 ) {
              $( '#tabIDDashboard' ).trigger( 'click' )
              // this.resetsearchfiletr( 'desc' )
              this.tabForPanarayCount++
            }
          } else {
            $( '#tabIDsearch' ).trigger( 'click' )
          }
        } else {
          /* if parameter set then changing tab */
          if ( tabid !== '' && tabid ) {
            if ( this.tabCountExternal === 0 ) {
              if ( localStorage.getlocalStorage( 'reloadStatus' ) === null ) {
                $( '#tabID' + tabid ).trigger( 'click' )
              } else {
                $( '#tabIDsearch' ).trigger( 'click' )
              }
              this.tabCountExternal++
            }
          }
        }
        window.onload = function () {
          /* On page reload reseting search parameter value condition */
          localStorage.savelocalStorage( 'serachResultload', 'false' )
          localStorage.destroyLocalStorage( 'reloadStatus' )
          localStorage.destroyLocalStorage( 'login' )
          /* Checking Global outlook tab if it is in tab then changing local storage globalotlook key as false */
          var allTabDetails = []
          allTabDetails = JSON.parse( localStorage.getlocalStorage( 'rvTabs' ) )
          for ( var i = 0; i < allTabDetails.length; i++ ) {
            if ( allTabDetails[i].id === 'globaloutlook' ) {
              localStorage.savelocalStorage( 'globaloutlookTab', false )
              break
            }
          }
        }
        localStorage.savelocalStorage( 'serachResultload', 'false' )
      }
    },
    applytheme() {
      if ( !this.auth ) {
        var allTabDetails = []
        allTabDetails = JSON.parse( localStorage.getlocalStorage( 'rvTabs' ) )
        if ( allTabDetails !== null ) {
          for ( var i = 0; i < allTabDetails.length; i++ ) {
            // if (allTabDetails[i].id == "globaloutlook" || allTabDetails[i].id == "post") {
            //     this.removetab(allTabDetails[i].id)
            // }
            if ( allTabDetails[i].id !== 'Dashboard' ) {
              this.removetab( allTabDetails[i].id )
            }
          }
        }
      }
      if ( this.$store.state.appsetting.theme == 'd' ) {
        this.theme = 'dark'
      } else if ( this.$store.state.appsetting.theme == 'l' ) {
        this.theme = 'light'
      } else {
        this.theme = 'webapp'
      }
      $( 'body' ).addClass( this.theme )
      $( 'html' ).addClass( this.theme )
    },

    closeTab( tabId ) {
      this.removetab( tabId )
      this.chartReload( false )
      this.globalOutlookReload( false )
    },
    activeTab( tabId ) {
      if ( this.activetabid() != tabId ) {
        this.globalOutlookReload( tabId )
        this.chartReload( tabId )
        footer( tabId )
        this.changeactivetab( tabId )
        this.updateScrollBounds()
        window.scrollTo( 0, 0 )
        this.lineLimitpage()
      }
    },
    globalOutlookReload( tabid ) {
      if ( tabid == false ) {
        var allTabDetails = []
        allTabDetails = JSON.parse( localStorage.getlocalStorage( 'rvTabs' ) )
        tabid = allTabDetails[allTabDetails.length - 1]['id']
      }
      if ( tabid === 'globaloutlook' ) {
        var iframurl = SITE_URL + 'research/dashboard/global-outlook/'
        if ( this.$store.state.appsetting.panaray ) {
          iframurl =
                        iframurl +
                        '?e=' +
                        this.$store.state.appsetting.encemail +
                        '&t=' +
                        this.$store.state.appsetting.theme
        }

        var gobalLocal = localStorage.getlocalStorage( 'globaloutlookTab' )
        if ( gobalLocal == 'false' ) {
          localStorage.savelocalStorage( 'globaloutlookTab', true )
          $( '#inlineFrameExample' ).attr( 'src', iframurl )
        }
      }
    },

    chartReload( tabid ) {
      if ( tabid == false ) {
        var allTabDetails = []
        allTabDetails = JSON.parse( localStorage.getlocalStorage( 'rvTabs' ) )
        tabid = allTabDetails[allTabDetails.length - 1]['id']
      }
      if ( tabid === 'Dashboard' ) {
        var iframurlchart = SITE_URL + 'won-focus-chart'
        if ( this.$store.state.appsetting.panaray ) {
          iframurlchart =
                        iframurlchart +
                        '?e=' +
                        this.$store.state.appsetting.encemail +
                        '&t=' +
                        this.$store.state.appsetting.theme
        }

        var gobalLocal = localStorage.getlocalStorage( 'chart' )
        if ( gobalLocal == 'false' ) {
          localStorage.savelocalStorage( 'chart', true )
          $( '.chartiframe' ).attr( 'src', iframurlchart )
        }
      }
    },

    changeTab() {
      //  console.log( 'change tab index', this.activeTabIndex() )
      this.activeTabIndex()
    },
    activeTabInx() {
      return this.activeTabIndex()
    },
    updateScrollBounds() {
      const { scrollTop, clientHeight } = this.$el
      this.scrollTop = scrollTop
      if ( this.scrollTop == 0 ) {
        $( '.scrolling-document' ).animate( { scrollTop: 10 }, 10 )
        $( 'canvas' ).css( { width: '100%', height: '100%' } )
      }
    },
    lineLimitpage: function () {
      $( document ).ready( function () {
        var windowSizeheightsearchan = $( window ).height()
        var windowSizeheightexsearchan = windowSizeheightsearchan - 414
        $( '.searchResultAnalyst' ).css(
          'min-height',
          windowSizeheightexsearchan + 'px'
        )
        $( '.pdf-viewer__main,.dashboardContantPdf' ).css(
          'min-height',
          windowSizeheightsearchan + 'px'
        )
        store_contents()
        update_ellipsis()
      } )

      var store_contents = function () {
        $( '.ellipsis' ).each( function () {
          var p = $( this )
          p.data( 'ellipsis-storage', p.html() )
        } )
      }

      var update_ellipsis = function () {
        $( '.ellipsis' ).each( function () {
          var p = $( this )
          var max_line_count = p.data( 'ellipsis-max-line-count' )
          var line_height = p.html( '&nbsp' ).outerHeight()
          var max_height = max_line_count * line_height
          p.html( p.data( 'ellipsis-storage' ) )
          var p_height = p.outerHeight()

          while ( p_height > max_height ) {
            var content_arr = p.html().split( ' ' )
            content_arr.pop()
            content_arr.pop()
            content_arr.push( '...' )
            p.html( content_arr.join( ' ' ) )
            p_height = p.outerHeight()
          }
        } )
      }
    }
  }, // End of Method
  beforeUpdate() {
    this.lineLimitpage()
  },
  mounted() { }
}

function footer( tabId ) {
  // $( '.footerMenu' ).removeClass( 'footerhide' )
  // if ( tabId == 'globaloutlook' ) {
  //   $( '.footerMenu' ).addClass( 'footerhide' )
  // }

  $( '.footerMenu' ).removeAttr( 'style' )
  if ( tabId == 'globaloutlook' ) {
    $( '.footerMenu' ).css( 'display', 'none' )
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/rvdashboard.js